var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"cl-666"},[_vm._v("404找不到页面。。。")])])
}]

export { render, staticRenderFns }